export const SPRING_CONFIGS = {
  smooth: { damping: 200 },
  snappy: { damping: 20, stiffness: 200 },
  bouncy: { damping: 12 },
  heavy: { damping: 15, stiffness: 80, mass: 2 },
} as const;
